import script from "./add.vue?vue&type=script&setup=true&lang=js"
export * from "./add.vue?vue&type=script&setup=true&lang=js"

import "./add.vue?vue&type=style&index=0&id=194f89b4&lang=css"
import "./add.vue?vue&type=style&index=1&id=194f89b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194f89b4"]])

export default __exports__